import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components/macro'
import Text from '../../../common/Text'
import { rem } from 'polished'
import { useAppContext } from '../../../../context/AppContext'
import { QuestionTransitions } from '../../../../style/transitions'
import { AnimatePresence, motion } from 'framer-motion'
import { ReactComponent as Loader } from '../../../../assets/images/loading.svg'
import MasterPage from '../../../common/MasterPage'
import Container from '../../../common/Container'

const countByAndExecute = (ms, fn) => {
  return setInterval(() => {
    fn()
  }, ms)
}

const ProcessingBoard = () => {
  // const { track } = useAnalytics()
  const {
    // quiz: { answers, setResult },
    media: { isMedium, isSmall },
  } = useAppContext()

  const [ellipsisCount, setEllipsisCount] = useState(3)

  useEffect(() => {
    let count = 0
    const interval = countByAndExecute(250, () => {
      setEllipsisCount(count++ % 4)
    })
    // setResult(answers)

    return () => clearInterval(interval)
  }, [])

  const heading = (
    <SearchText>
      Finding the perfect trip for you
      {!isMedium && <br />}
      <Ellipses>{[...Array(ellipsisCount).keys()].map(() => '.')}</Ellipses>
    </SearchText>
  )

  return (
    <MasterPage
      isResults
      hideCaption
      showProgress={false}
      heading={heading}
      showCaption={false}
    >
      <AnimatePresence exitBeforeEnter>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
        >
          <ProcessContainer>
            <StyledMotion
              initial={QuestionTransitions.initial}
              animate={QuestionTransitions.animate}
              exit={QuestionTransitions.exit}
              transition={QuestionTransitions.transition(0.7, 0)}
            >
              <BuckleUpContainer
                isSmall={isSmall}
                initial={QuestionTransitions.initial}
                animate={QuestionTransitions.animate}
                exit={QuestionTransitions.exit}
                transition={QuestionTransitions.transition(0.7, 0.25)}
              >
                <SpinContainer>
                  <Spinner />
                </SpinContainer>
              </BuckleUpContainer>
            </StyledMotion>
          </ProcessContainer>
        </motion.div>
      </AnimatePresence>
    </MasterPage>
  )
}

ProcessingBoard.propTypes = {}

export default ProcessingBoard

const SearchText = styled.div`
  position: relative;
  display: inline-flex;
  padding: 0.5em;
`
const Ellipses = styled.span`
  min-width: 20px;
  text-align: left;
  display: inline-block;
  position: absolute;
  left: 100%;
`
const BuckleUpContainer = styled(motion.div)`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-content: center;
    align-items: center;

    img {
      width: 70%;
      height: 70%;
      object-fit: contain;
    }

    ${Text} {
      margin-top: ${theme.space(1)};
      width: ${rem(330)};
      text-align: center;

      ${theme.media.md`
        width: ${rem(500)};
        text-align: center;


      `}
    }

    ${theme.media.lg`
      top: ${rem(300)};
      width: 100%;
      
      img {
        width: ${rem(370)}};
        height: ${rem(112)}};
      }
    `};

    ${theme.media.xl`
      img {
        width: ${rem(530)}};
        height: ${rem(160)}};
      }
    
    `};
  `}
`

const Spinner = styled(Loader)`
  width: 100%;
  height: auto;
`
const SpinContainer = styled.div`
  ${({ theme }) => css`
    width: 20%;
    max-width: ${rem(144)};
    margin-bottom: 1em;

    ${theme.media.lg`
      margin-bottom: 2em;
      width: 10%;
    `}
  `}
`
const ProcessContainer = styled(Container)``
const StyledMotion = styled(motion.div)`
  position: relative;
`
